/*
  Gyurusdoboz upsell - kosarba tesz egy dobozt, es egyszerre csak egy doboz maradhat a kosarban.
  Modositva: Akos Hegel | branch: dev/akos | 2026-09-10 - masik doboz valasztasakor a korabbi doboz torlodik
*/

class CartBoxUpsell extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('button[type="submit"]');
    this.buttonText = this.querySelector('[data-button-text]');
    this.error = this.querySelector('[role="alert"]');

    if (!this.form || !this.button || this.button.disabled) return;
    this.form.addEventListener('submit', (event) => this.addToCart(event));
  }

  get boxProductIds() {
    const holder = this.closest('[data-cart-box-product-ids]');
    if (!holder) return [];

    return holder.dataset.cartBoxProductIds
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
  }

  get selectedVariantId() {
    return String(this.form.querySelector('input[name="id"]')?.value || '');
  }

  async addToCart(event) {
    event.preventDefault();
    this.button.disabled = true;
    this.error.hidden = true;
    const originalText = this.buttonText.textContent;
    this.buttonText.textContent = 'Hozzáadás…';

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(this.form),
      });

      if (!response.ok) {
        const result = await response.json();
        throw new Error(result.description || 'A terméket nem sikerült a kosárba helyezni.');
      }

      await this.removeOtherBoxes();

      window.location.reload();
    } catch (error) {
      this.error.textContent = error.message;
      this.error.hidden = false;
      this.button.disabled = false;
      this.buttonText.textContent = originalText;
    }
  }

  // Az uj doboz mar a kosarban van, ezert a tobbi doboz sorat nullara allitjuk.
  async removeOtherBoxes() {
    const productIds = this.boxProductIds;
    if (productIds.length === 0) return;

    const keptVariantId = this.selectedVariantId;

    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) return;

    const cart = await response.json();
    const removableVariantIds = [
      ...new Set(
        cart.items
          .filter((item) => productIds.includes(String(item.product_id)))
          .map((item) => String(item.variant_id))
          .filter((variantId) => variantId !== keptVariantId)
      ),
    ];

    if (removableVariantIds.length === 0) return;

    const updates = {};
    removableVariantIds.forEach((variantId) => {
      updates[variantId] = 0;
    });

    await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
  }
}

class CartBoxUpsellSection extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    document.addEventListener('shopify:cart:lines-update', () => this.refreshVisibility(), {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  async refreshVisibility() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return;

      const cart = await response.json();
      this.hidden = cart.item_count === 0;
    } catch (error) {
      console.warn('A gyűrűsdoboz-ajánló állapota nem frissíthető.', error);
    }
  }
}

if (!customElements.get('cart-box-upsell')) {
  customElements.define('cart-box-upsell', CartBoxUpsell);
}

if (!customElements.get('cart-box-upsell-section')) {
  customElements.define('cart-box-upsell-section', CartBoxUpsellSection);
}
